import { useState, useEffect } from 'react';
import { getUserProfile } from '../api/api';

export function usePartner() {
  const [partnerId, setPartnerId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchPartnerInfo = async () => {
      try {
        setLoading(true);
        const userProfile = await getUserProfile();

        // Check for entityType case-insensitively to handle both 'partner' and 'PARTNER'
        // Also handle the case where entityType might be null or undefined
        const entityType = userProfile.entityType?.toLowerCase() || '';
        if (userProfile.entityId && (entityType === 'partner' || entityType === 'partner')) {
          setPartnerId(userProfile.entityId);
        }
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch partner info:', err);
        setError(err instanceof Error ? err : new Error('Failed to fetch partner info'));
        setLoading(false);
      }
    };

    fetchPartnerInfo();
  }, []);

  return { partnerId, loading, error };
}
